const path = '/assets/images/payment_method/'

export const vaKey = "bank_transfer"

export let paymentMethods = {
	description: {
		va_number: 'Virtual Account',
		emoney: 'Pembayaran Instan',
		bank_transfer: 'Transfer Bank (verifikasi manual 1x24 jam)',
		credit_card: 'Kartu Kredit (verifikasi otomatis)'
	},
	va_number: [
		{
			label: 'Mandiri Virtual Account',
			key: 'mandiri',
			image: `${path}mandiri.png`
		},
		{
			label: 'BRI Virtual Account',
			key: 'bri',
			image: `${path}bri.png`	
		},
		{
			label: 'BCA Virtual Account',
			key: 'bca',
			image: `${path}bca.png`	
		},
		{
			label: 'BNI Virtual Account',
			key: 'bni',
			image: `${path}bni.png`	
		},
		{
			label: 'BSI Virtual Account',
			key: 'bsi',
			image: `${path}bsi.png`	
		},
		{
			label: 'Permata Virtual Account',
			key: 'permata',
			image: `${path}permata.png`	
		}
	],
	bank_transfer: [
		{
			label: 'Transfer BNI',
			key: 'bni',
			image: `${path}bni.png`	
		},
		{
			label: 'Transfer BRI',
			key: 'bri',
			image: `${path}bri.png`	
		},
		{
			label: 'Transfer Mandiri',
			key: 'mandiri',
			image: `${path}mandiri.png`	
		},
		{
			label: 'Transfer BCA',
			key: 'bca',
			image: `${path}bca.png`	
		}
	],
	emoney: [
		{
			label: 'Gopay',
			key: 'gopay',
			image: `${path}gopay.png`	
		},
		{
			label: 'DANA',
			key: 'dana',
			image: `${path}dana.png`	
		},
		{
			label: 'Shopeepay',
			key: 'shopeepay',
			image: `${path}shopeepayqris.png`	
		},
		{
			label: 'LinkAja',
			key: 'linkaja',
			image: `${path}linkaja.png`	
		}
	],
	credit_card: [
		{
			label: 'Credit Card',
			key: 'credit_card',
			image: `${path}cc.png`
		}
	]
}

// let allowed = [{ type: 'bank_transfer', key: 'bni' }]

// Object.keys(paymentMethods).map(key => {
// 	if(key != 'description') {
//     	paymentMethods[key].map(item => {
//         	let find = allowed.find(pay => pay.type == key && pay.key == item.key)
//         	if(find) {
//         	}
//         })
        
// 	}
// })